export default function contactForm() {
    const form = document.getElementById("contact-me");
    if (!form) {
        return;
    }

    form.addEventListener("submit", async (event) => {
        event.preventDefault();
        const status = document.getElementById("my-form-status");

        try {
            const response = await fetch(event.target.action, {
                method: form.method,
                body: new FormData(event.target),
                headers: {
                    Accept: "application/json",
                },
            });

            if (response.ok) {
                window.location.replace('/thanks/');
                return;
            }

            const responseData = await response.json();

            if (Object.hasOwn(responseData, "errors")) {
                status.innerHTML = data["errors"].map(error => error["message"]).join(", ");
                return;
            }
        } catch {
            // /shrug
        }

        status.innerHTML = "Oops! There was a problem submitting your form";
    });
}
